import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, forwardRef, useState, useImperativeHandle } from "react";
import { ArrowLeftOutlined, FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import AssetMapDetail from "@/components/AssetMapDetail";
const AssetMap3D = forwardRef(({ className = "", fontSize = 16 }, ref) => {
    const elementRef = useRef(null);
    const [isFullscreen, setFullscreen] = useState(!!document.fullscreenElement);
    const toggleFullsreen = () => {
        if (document.fullscreenElement) {
            document.exitFullscreen();
            setFullscreen(false);
        }
        else {
            elementRef.current?.requestFullscreen();
            setFullscreen(true);
        }
    };
    const childRef = useRef(null);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [selectedAssetDetail, setSelectedAssetDetail] = useState(null);
    const [assetTitle, setAssetTitle] = useState('');
    const [cameraLock, setCameraLock] = useState(false);
    useImperativeHandle(ref, () => ({
        stopRenderLoop: () => {
            childRef?.current?.stopRenderLoop?.();
        },
        renRenderLoop: () => {
            childRef?.current?.renRenderLoop?.();
        },
    }));
    const onBuildingEnter = (name, id) => {
        setAssetTitle(name);
    };
    const onBuildingLeave = (name, id) => {
        setAssetTitle('');
    };
    const onBuildingClick = (name, id) => {
        setAssetTitle(name);
        setSelectedAsset(null);
        setTimeout(() => setSelectedAsset({ id, name }));
    };
    const onCameraFocus = () => {
        setCameraLock(true);
    };
    const onCameraBlur = () => {
        setSelectedAsset(null);
        setCameraLock(false);
        setAssetTitle('');
    };
    const handlePointDetail = (data) => {
        console.log(data);
    };
    return (_jsxs("div", { className: "relative h-full", ref: elementRef, children: [_jsx(AssetMapDetail, { ref: childRef, className: "h-full", jsonUrl: "assets/models/sanji.json", fontSize: fontSize, onBuildingEnter: onBuildingEnter, onBuildingLeave: onBuildingLeave, onBuildingClick: onBuildingClick, onCameraFocus: onCameraFocus, onCameraBlur: onCameraBlur }), _jsx("div", { className: "absolute top-[0.1rem] right-[0.1rem] z-10 flex items-center gap-[0.2rem]", children: _jsx("a", { className: "text-white text-[0.24rem] font-medium cursor-pointer", onClick: toggleFullsreen, title: '切换全屏' + isFullscreen, children: isFullscreen ? _jsx(FullscreenExitOutlined, {}) : _jsx(FullscreenOutlined, {}) }) }), cameraLock && (_jsx("div", { className: "absolute top-0 left-1", style: { top: '-.75rem' }, children: _jsx(Button, { style: { background: 'color-mix(in oklab, var(--color-gray-900) 38%, transparent)' }, onClick: () => { childRef?.current?.cameraBlur?.(); }, size: "large", color: "default", variant: "solid", shape: "circle", icon: _jsx(ArrowLeftOutlined, {}) }) })), selectedAsset && (_jsx("div", { className: "absolute z-20 top-[0.1rem] right-[0.4rem] p-1 text-white border top-1 right-1 bg-gray-900/38 border-gray-600/0 min-w-6", style: { animation: 'fadeInRight 1s both', padding: 10, borderRadius: 10 }, children: _jsx("div", { className: "text-xs", style: { fontSize: `${fontSize / 100}rem`, lineHeight: 1.5 }, children: selectedAsset.name && (_jsxs("div", { className: "flex justify-between", style: { marginBottom: 5 }, children: [_jsxs("span", { className: "flex items-center text-white", children: [_jsx("img", { src: "assets/images/icon01.png", style: { width: 20, height: 21, marginRight: 10 } }), selectedAsset.name] }), _jsx("span", {})] })) }) })), assetTitle && (_jsx("div", { className: "absolute top-0 z-20 text-white transform -translate-x-1/2 border left-1/2 bg-gray-900/38 border-gray-600/0 min-w-1", style: { padding: 10, borderRadius: 10, top: 10 }, children: _jsx("div", { style: { fontSize: `${fontSize / 100}rem` }, children: assetTitle }) }))] }));
});
export default AssetMap3D;
